<template>
    <div class="testaccount-overlay">
        <div class="testaccount-overlay--backdrop"
                @click="onBackgroundClicked"/>

        <div class="testaccount-overlay--content-wrapper grid grid__base">
            <overlay-close-btn/>

            <div class="grid--row testaccount-overlay--row">
                <div class="grid--col testaccount-overlay--col">
                    <div class="testaccount-overlay--content">
                        <iframe class="testaccount-overlay--frame"
                                frameborder="0"
                                :src="url"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import OverlayCloseBtn from 'framework/global-components/dyn/overlay-close-btn/overlay-close-btn';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: { OverlayCloseBtn },
        computed: {
            ...mapGetters('overlay', ['currentOverlay']),
            url() {
                const language = globals.config.language;
                return `https://testaccount.datatrans.com/testaccounts?lang=${ language }`;
            },
        },

        methods: {
            ...mapActions('scroll', ['disableScroll']),
            onBackgroundClicked() {
                this.closeOverlay({ id: this.currentOverlay.id });
            },
        },
        beforeDestroy() {
            this.disableScroll({ isLocked: false });
        },
        mounted() {
            this.disableScroll({ isLocked: true });
        },
    };
</script>
